var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsAlpha, IsUppercase } from "class-validator";
import { GraphQLNonEmptyString, NonNegativeIntResolver } from "graphql-scalars";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { SolicitationCodeNode, SolicitationCodeTag, } from "../resources/SolicitationCode.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListSolicitationCodesArgs = class ListSolicitationCodesArgs extends FilteredListQueryArgs("SolicitationCodeResolver", ["name", "prefix", "code", "tags", "text", "createdAt", "updatedAt"]) {
};
ListSolicitationCodesArgs = __decorate([
    ArgsType()
], ListSolicitationCodesArgs);
export { ListSolicitationCodesArgs };
let ListSolicitationCodesResponse = class ListSolicitationCodesResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [SolicitationCodeNode], { nullable: false }),
    __metadata("design:type", Array)
], ListSolicitationCodesResponse.prototype, "data", void 0);
ListSolicitationCodesResponse = __decorate([
    ObjectType("ListSolicitationCodesResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListSolicitationCodesResponse);
export { ListSolicitationCodesResponse };
let SetSolicitationCodeInput = class SetSolicitationCodeInput {
    name;
    tags;
    teamIds;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetSolicitationCodeInput.prototype, "name", void 0);
__decorate([
    Field(() => [SolicitationCodeTag], { nullable: false }),
    __metadata("design:type", Array)
], SetSolicitationCodeInput.prototype, "tags", void 0);
__decorate([
    Field(() => [GlobalIdScalar], { nullable: false }),
    __metadata("design:type", Array)
], SetSolicitationCodeInput.prototype, "teamIds", void 0);
SetSolicitationCodeInput = __decorate([
    InputType("SetSolicitationCodeInput")
], SetSolicitationCodeInput);
export { SetSolicitationCodeInput };
let CreateSolicitationCodeInput = class CreateSolicitationCodeInput {
    prefix;
    code;
    name;
    tags;
};
__decorate([
    IsAlpha(),
    IsUppercase(),
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateSolicitationCodeInput.prototype, "prefix", void 0);
__decorate([
    Field(() => NonNegativeIntResolver, { nullable: false }),
    __metadata("design:type", Number)
], CreateSolicitationCodeInput.prototype, "code", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreateSolicitationCodeInput.prototype, "name", void 0);
__decorate([
    Field(() => [SolicitationCodeTag], { nullable: false }),
    __metadata("design:type", Array)
], CreateSolicitationCodeInput.prototype, "tags", void 0);
CreateSolicitationCodeInput = __decorate([
    InputType("CreateSolicitationCodeInput")
], CreateSolicitationCodeInput);
export { CreateSolicitationCodeInput };
//# sourceMappingURL=SolicitationCodeInput.js.map